export default __webpack_public_path__ + "static/media/video.e1d47bd3.mp4";